import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import ImageButtonList from "../common/imageButtonList";
import ImageText from "../common/imageText";
import NavigationBar from "../common/navigationBar";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../actions/application";

class CareTeamList extends Component {
  /**************
   * Properties *
   **************/
  state = {
    currentPatient: this.props.currentPatient,
    default: [
      {
        id: "careTeamMember1",
        to: "/care_team/details/careTeam1/1",
        highlight: require("./images/1274_CareTeam1_HL.png"),
        unhighlight: require("./images/1274_CareTeam1_UH.png"),
        highlight2: require("./images/1274_CareTeam1_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember2",
        to: "/care_team/details/careTeam2/1",
        highlight: require("./images/1274_CareTeam2_HL.png"),
        unhighlight: require("./images/1274_CareTeam2_UH.png"),
        highlight2: require("./images/1274_CareTeam2_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember3",
        to: "/care_team/details/careTeam3/1",
        highlight: require("./images/1274_CareTeam3_HL.png"),
        unhighlight: require("./images/1274_CareTeam3_UH.png"),
        highlight2: require("./images/1274_CareTeam3_photo.png"),
        unhighlight2: null,
      },
    ],
    orthoPatient: [
      {
        id: "careTeamMember1",
        to: "/care_team/details/careTeam1/1",
        highlight: require("./images/1274_CareTeam1_HL.png"),
        unhighlight: require("./images/1274_CareTeam1_UH.png"),
        highlight2: require("./images/1274_CareTeam1_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember2",
        to: "/care_team/details/careTeam2/1",
        highlight: require("./images/1274_CareTeam2_HL.png"),
        unhighlight: require("./images/1274_CareTeam2_UH.png"),
        highlight2: require("./images/1274_CareTeam2_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember3",
        to: "/care_team/details/careTeam3/1",
        highlight: require("./images/1274_CareTeam3_HL.png"),
        unhighlight: require("./images/1274_CareTeam3_UH.png"),
        highlight2: require("./images/1274_CareTeam3_photo.png"),
        unhighlight2: null,
      },
    ],
    chfPatient: [
      {
        id: "careTeamMember4",
        to: "/care_team/details/careTeam4/1",
        highlight: require("./images/1274_CareTeam4_HL.png"),
        unhighlight: require("./images/1274_CareTeam4_UH.png"),
        highlight2: require("./images/1274_CareTeam4_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember5",
        to: "/care_team/details/careTeam5/1",
        highlight: require("./images/1274_CareTeam5_HL.png"),
        unhighlight: require("./images/1274_CareTeam5_UH.png"),
        highlight2: require("./images/1274_CareTeam5_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember6",
        to: "/care_team/details/careTeam6/1",
        highlight: require("./images/1274_CareTeam6_HL.png"),
        unhighlight: require("./images/1274_CareTeam6_UH.png"),
        highlight2: require("./images/1274_CareTeam6_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember7",
        to: "/care_team/details/careTeam7/1",
        highlight: require("./images/1274_CareTeam7_HL.png"),
        unhighlight: require("./images/1274_CareTeam7_UH.png"),
        highlight2: require("./images/1274_CareTeam7_photo.png"),
        unhighlight2: null,
      },
    ],
    pediatricPatient: [
      {
        id: "careTeamMember8",
        to: "/care_team/details/careTeam8/1",
        highlight: require("./images/1274_CareTeam8_HL.png"),
        unhighlight: require("./images/1274_CareTeam8_UH.png"),
        highlight2: require("./images/1274_CareTeam8_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember6",
        to: "/care_team/details/careTeam6/1",
        highlight: require("./images/1274_CareTeam6_HL.png"),
        unhighlight: require("./images/1274_CareTeam6_UH.png"),
        highlight2: require("./images/1274_CareTeam6_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember9",
        to: "/care_team/details/careTeam9/1",
        highlight: require("./images/1274_CareTeam9_HL.png"),
        unhighlight: require("./images/1274_CareTeam9_UH.png"),
        highlight2: require("./images/1274_CareTeam9_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember7",
        to: "/care_team/details/careTeam7/1",
        highlight: require("./images/1274_CareTeam7_HL.png"),
        unhighlight: require("./images/1274_CareTeam7_UH.png"),
        highlight2: require("./images/1274_CareTeam7_photo.png"),
        unhighlight2: null,
      },
    ],
    oncologyPatient: [
      {
        id: "careTeamMember10",
        to: "/care_team/details/careTeam10/1",
        highlight: require("./images/1274_CareTeam10_HL.png"),
        unhighlight: require("./images/1274_CareTeam10_UH.png"),
        highlight2: require("./images/1274_CareTeam10_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember11",
        to: "/care_team/details/careTeam11/1",
        highlight: require("./images/1274_CareTeam11_HL.png"),
        unhighlight: require("./images/1274_CareTeam11_UH.png"),
        highlight2: require("./images/1274_CareTeam11_photo.png"),
        unhighlight2: null,
      },
      {
        id: "careTeamMember12",
        to: "/care_team/details/careTeam12/1",
        highlight: require("./images/1274_CareTeam12_HL.png"),
        unhighlight: require("./images/1274_CareTeam12_UH.png"),
        highlight2: require("./images/1274_CareTeam12_photo.png"),
        unhighlight2: null,
      },
    ],
    textImage: require("./images/1274_elements_bannerinfo.png"),
    arrowUp: require("../common/images/Arrow_up.png"),
    arrowDown: require("../common/images/Arrow_down.png"),
    navigationBar: {
      back: true,
      backRoute: "/main_menu",
      mainMenu: true,
      navigate: true,
    },
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let patient = null;
    switch (this.state.currentPatient) {
      case "orthoPatient":
        patient = this.state.orthoPatient;
        break;
      case "chfPatient":
        patient = this.state.chfPatient;
        break;
      case "pediatricPatient":
        patient = this.state.pediatricPatient;
        break;
      case "oncologyPatient":
        patient = this.state.oncologyPatient;
        break;
      default:
        patient = this.state.default;
    }
    return (
      <div className="care-team-list">
        <ImageText id="text" src={this.state.textImage} />
        <ImageButtonList imageButtons={patient} flexClass="flex-vertical" />
        <div className="arrows">
          <img className="arrow-up" src={this.state.arrowUp} alt="" />
          <img className="arrow-down" src={this.state.arrowDown} alt="" />
        </div>
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedCareTeamList = connect(
  (state) => ({
    context: state.application.currentContext,
    currentPatient: state.application.currentPatient,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(CareTeamList);

export default withRouter(ConnectedCareTeamList);
